import React from 'react';
import { CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, Button, Radio, Typography, FormControlLabel } from '@material-ui/core';
class PrintOptionDialog extends React.Component {
    state = { fields: {} };

    handleChange = (id) => {
        let fields = this.state.fields;
        let newdetails = fields.branch.map((details, i) => {
            if (id !== i) {
                return { ...details, defaultBranch: false }
            }
            else {
              return { ...details, defaultBranch: true }
            }
          })
        fields.branch = newdetails;
        this.setState({ fields });
    }

    componentDidMount() {
        const { branch } = this.props;
        if (branch && branch.length > 0) {
            let fields = this.state.fields;
            fields.branch = branch;
            this.setState({ fields });
        }
    }

    render() {
        const { open, handleClose, handleSubmit, saving } = this.props;
        const { fields } = this.state;

        return (
            <Dialog open={open} aria-labelledby="form-dialog-title" 
                // onClose={handleClose} 
            >
                <DialogTitle id="form-dialog-title">Choose Branch</DialogTitle>
                <DialogContent dividers>
                    <label>
                        {
                            fields.branch && fields.branch.length > 0 ?
                                fields.branch.map((b, id) => (
                                    <div key={id} style={{ margin: "4px 0px" }}>
                                        <FormControlLabel
                                            control={<Radio checked={b.defaultBranch} onChange={() => this.handleChange(id)} name="defaultBranch" color='primary' style={{ height: 0 }} />}
                                            label={<Typography variant="caption">{b.branchName}</Typography>}
                                        />
                                    </div>
                                ))
                            : null
                        }
                    </label>
                </DialogContent>
                {saving ?
                <DialogActions>
                    <Button disabled size='small'><CircularProgress size={25} style={{ marginRight: 8 }} /> Saving...</Button>
                </DialogActions> :
                <DialogActions>
                    <Button onClick={handleClose} color="default" size='small'>cancel</Button>
                    <div style={{ flexGrow: 1 }} />
                    <Button onClick={() => handleSubmit(fields)} color="primary" size='small' autoFocus>submit</Button>
                </DialogActions>}
            </Dialog>
        )
    }
}
export default PrintOptionDialog